import React from "react";
import Typed from "react-typed";
import { Link } from "react-scroll";

function Herosection(props) {
  // const { x, y } = props.position;
  // const { height, width } = props.elementDimensions;
  // const activeParallax = (depth = 15) => {
  //   let posX = (width / 2 - x) / depth;
  //   let posY = (height / 2 - y) / depth;
  //   return {
  //     transform: `translate(${posX}px, ${posY}px)`,
  //   };
  // };

  return (
    <section
      id="home"
      className={
        props.light
          ? "home d-flex align-items-center light"
          : "home d-flex align-items-center"
      }
    >
      <div className="container">
        <div className="intro">
          <img src="/images/AvatarMaker.png" alt="yurita-avatar" className="mb-4" />

          <h1 className="mb-2 mt-0">Yuri Baptista</h1>
          <p>
            Soy{" "}
            <Typed
              strings={[
                "",
                "Maquilladora cruelty-free",
                "Manicurista cruelty-free",
                "Estudiante de front-end",
              ]}
              typeSpeed={80}
              backSpeed={40}
              attr="value"
              loop
            >
              <label value></label>
            </Typed>
          </p>

          <ul className="social-icons light list-inline mb-0 mt-4">
            <li className="list-inline-item">
              <a href="https://www.instagram.com/yurita_makeup/?hl=es-la" target="_ blank rel-nonopener" >
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://twitter.com/Yuritalinda" target="_blank rel-nonopener">
                <i className="fab fa-twitter"></i>
              </a>
            </li>
            
          </ul>

          <div className="mt-4">
            <Link
              className="btn btn-default"
              to="section-contact"
              spy={true}
              smooth={true}
              duration={500}
            >
              Contratame
            </Link>
          </div>
        </div>

        <div className="scroll-down">
          <Link
            to="section-about"
            spy={true}
            smooth={true}
            duration={700}
            className="mouse-wrapper"
          >
            {/* <span>Baja</span> */}
            <span className="mouse">
              <span className="wheel"></span>
            </span>
          </Link>
        </div>

        
      </div>
    </section>
  );
}

export default Herosection;
